import { useState, useEffect } from "react";
import { RadioButton } from "primereact/radiobutton";
import { ContentRadio } from "./ContentRadio";
import { Input } from "../../../../components/Input/Input";
import _ from "lodash";
import useCompanySetting from "../../../../hooks/company/useCompanySetting";
import SendButton from "./SendButton";

export const AssistComponent = ({ ConfigChange, setConfigChange }) => {
  let stateWorkCenterInit = {
    verifyBiometricData: false,
    workCenterRestriction: true,
    workCenterSize: "500",
    toleranceBeforeEntry: "120",
    toleranceBeforeExit: "60",
    toleranceAfterExit: "180",
    homeOfficeQuantity: "3",
  };
  const [attendance, setAttendance] = useState(stateWorkCenterInit);
  const [tempAttendance, setTempAttendance] = useState({});
  const { postCompanySettingAttendance, getCompanySettings, companySettings } =
    useCompanySetting();

  useEffect(() => {
    if (_.isEqual(attendance, tempAttendance)) {
      setConfigChange({ ...ConfigChange, AssistChange: false });
    } else {
      setConfigChange({ ...ConfigChange, AssistChange: true });
    }
  }, [attendance]);

  useEffect(() => {
    if (companySettings === undefined) {
      getCompanySettings();
    } else {
      if (
        (companySettings.workCenterRestriction === null ||
          companySettings.workCenterRestriction === undefined) &&
        (companySettings.workCenterSize === null ||
          companySettings.workCenterSize === undefined) &&
        (companySettings.toleranceBeforeEntry === null ||
          companySettings.toleranceBeforeEntry === undefined) &&
        (companySettings.toleranceBeforeExit === null ||
          companySettings.toleranceBeforeExit === undefined) &&
        (companySettings.homeOfficeQuantity === null ||
          companySettings.homeOfficeQuantity === undefined) &&
        (companySettings.toleranceAfterExit === null ||
          companySettings.toleranceAfterExit === undefined)
      ) {
        setAttendance(stateWorkCenterInit);
        setTempAttendance(stateWorkCenterInit);
      } else {
        const tempHQuantity =
          companySettings.homeOfficeQuantity !== null
            ? companySettings.homeOfficeQuantity
            : "3";
        const tempWorkCenterSize =
          companySettings.workCenterSize !== null
            ? companySettings.workCenterSize
            : "500";
        const tempToleranceBeforeExit =
          companySettings.toleranceBeforeExit !== null
            ? companySettings.toleranceBeforeExit
            : "60";
        const tempToleranceBeforeEntry =
          companySettings.toleranceBeforeEntry !== null
            ? companySettings.toleranceBeforeEntry
            : "120";
        const tempToleranceAfterExit =
          companySettings.toleranceAfterExit !== null
            ? companySettings.toleranceAfterExit
            : "180";

        companySettings.workCenterSize = null;
        companySettings.homeOfficeQuantity = null;
        if (!companySettings.workCenterRestriction) {
          companySettings.workCenterSize = tempWorkCenterSize;
          companySettings.homeOfficeQuantity = tempHQuantity;
        }

        companySettings.toleranceBeforeExit = tempToleranceBeforeExit;
        companySettings.toleranceBeforeEntry = tempToleranceBeforeEntry;
        companySettings.toleranceAfterExit = tempToleranceAfterExit;

        const companySettingsModified = {
          ...attendance,
          workCenterRestriction: companySettings.workCenterRestriction,
          workCenterSize: tempWorkCenterSize,
          homeOfficeQuantity: tempHQuantity,
          verifyBiometricData: companySettings.verifyBiometricData,
          toleranceBeforeEntry: tempToleranceBeforeEntry,
          toleranceBeforeExit: tempToleranceBeforeExit,
          toleranceAfterExit: tempToleranceAfterExit,
        };

        setAttendance(companySettingsModified);
        setTempAttendance(companySettingsModified);
      }
    }
  }, [companySettings]);

  useEffect(() => {
    setErrors({
      toleranceBeforeEntry:
        attendance.toleranceBeforeEntry === undefined ||
        attendance?.toleranceBeforeEntry?.length === 0 ||
        attendance.toleranceBeforeEntry === null,
      toleranceBeforeExit:
        attendance.toleranceBeforeExit === undefined ||
        attendance?.toleranceBeforeExit?.length === 0 ||
        attendance.toleranceBeforeExit === null,
      toleranceAfterExit:
        attendance.toleranceAfterExit === undefined ||
        attendance?.toleranceAfterExit?.length === 0 ||
        attendance.toleranceAfterExit === null,
    });
  }, [attendance]);

  const [errors, setErrors] = useState({
    toleranceBeforeEntry:
      attendance.toleranceBeforeEntry === undefined ||
      attendance?.toleranceBeforeEntry?.length === 0 ||
      attendance.toleranceBeforeEntry === null,
    toleranceBeforeExit:
      attendance.toleranceBeforeExit === undefined ||
      attendance?.toleranceBeforeExit?.length === 0 ||
      attendance.toleranceBeforeExit === null,
    toleranceAfterExit:
      attendance.toleranceAfterExit === undefined ||
      attendance?.toleranceAfterExit?.length === 0 ||
      attendance.toleranceAfterExit === null,
  });

  const handleInput = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      const { name, value } = e.target;
      let valueData = value.trim() === "" ? undefined : value;

      setAttendance({
        ...attendance,
        [name]: valueData,
      });

      if (e.target.value === "") {
        setErrors({
          ...errors,
          [name]: true,
        });
      } else {
        setErrors({
          ...errors,
          [name]: false,
        });
      }
    }
  };

  const renderRadioButtonContentType = () => {
    return (
      <ContentRadio
        name={"Registro de asistencia con:"}
        labelRadio1={"Biométricos (Huella y/o reconocimiento facial)"}
        labelRadio2={"Sin biométricos"}
        id1={"withBio"}
        radio1={
          <RadioButton
            inputId="withBio"
            name="biometric"
            value={true}
            onChange={(e) =>
              setAttendance({ ...attendance, verifyBiometricData: e.value })
            }
            checked={attendance.verifyBiometricData === true}
          />
        }
        id2={"withoutBio"}
        radio2={
          <RadioButton
            inputId="withoutBio"
            name="biometric"
            value={false}
            onChange={(e) =>
              setAttendance({ ...attendance, verifyBiometricData: e.value })
            }
            checked={attendance.verifyBiometricData === false}
          />
        }
      />
    );
  };

  const renderContentStartWork = () => {
    return (
      <div className="flex w-full flex-row h-20">
        <div className="flex h-full w-full flex-col">
          <p className="h-4">{"Se considera registro de entrada:"}</p>
          <div className="flex flex-col pl-2 space-y-2">
            <div className="flex flex-row content-center items-center space-x-2">
              <Input
                value={
                  attendance.toleranceBeforeEntry === undefined ||
                  attendance.toleranceBeforeEntry === null
                    ? ""
                    : attendance.toleranceBeforeEntry
                }
                className={"flex w-full h-4 !rounded-lg text-left"}
                classNameContent={"w-32 h-4 !rounded-lg"}
                onChange={(e) => handleInput(e)}
                name={"toleranceBeforeEntry"}
              />
              <p>{"minutos antes del inicio del turno"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderContentEndWork = () => {
    return (
      <div className="flex w-full flex-row h-20">
        <div className="flex h-full w-full flex-col">
          <p className="h-4">{"Se considera registro de salida:"}</p>
          <div className="flex flex-col pl-2 space-y-2">
            <div className="flex flex-row content-center items-center space-x-2">
              <Input
                value={
                  attendance.toleranceBeforeExit === undefined ||
                  attendance.toleranceBeforeExit === null
                    ? ""
                    : attendance.toleranceBeforeExit
                }
                className={"flex w-full h-4 !rounded-lg text-left"}
                classNameContent={"w-32 h-4 !rounded-lg"}
                onChange={(e) => handleInput(e)}
                name={"toleranceBeforeExit"}
              />
              <p>{"minutos antes del fin del turno"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContentLimit = () => {
    return (
      <div className="flex w-full flex-row h-20">
        <div className="flex h-full w-full flex-col">
          <p className="h-4">{"Límite de registro de salida:"}</p>
          <div className="flex flex-col pl-2 space-y-2">
            <div className="flex flex-row content-center items-center space-x-2">
              <Input
                value={
                  attendance.toleranceAfterExit === undefined ||
                  attendance.toleranceAfterExit === null
                    ? ""
                    : attendance.toleranceAfterExit
                }
                className={"flex w-full h-4 !rounded-lg text-left"}
                classNameContent={"w-32 h-4 !rounded-lg"}
                onChange={(e) => handleInput(e)}
                name={"toleranceAfterExit"}
              />
              <p>{"minutos después del fin del turno"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="flex !w-full !h-full flex-col relative">
      <div className="flex w-full h-full relative">
        <div className="flex flex-col inset-0 absolute overflow-auto p-3 gap-2">
          {renderRadioButtonContentType()}
          {renderContentStartWork()}
          {renderContentEndWork()}
          {renderContentLimit()}
        </div>
      </div>
      <SendButton
        disabled={Object.values(errors).indexOf(true) !== -1}
        onClick={async () => {
          if (Object.values(errors).indexOf(true) === -1) {
            const att = {
              ...attendance,
              workCenterSize: attendance.workCenterRestriction
                ? null
                : attendance.workCenterSize,
              homeOfficeQuantity: attendance.workCenterRestriction
                ? null
                : attendance.homeOfficeQuantity,
            };
            var result = await postCompanySettingAttendance(att);
            if (result.status === 200) {
              setTempAttendance(att);
              setConfigChange({ ...ConfigChange, AssistChange: false });
            }
          }
        }}
      />
    </div>
  );
};
